import { Box, Stack, Typography } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import { Modal } from 'framework/ui/ui-builder';
import type { SyberryTodaySkipCheckInModalProps } from '../../types';

const SyberryTodaySkipCheckInModal = ({
  isOpen,
  isPostponing,
  isSkipping,
  onClose,
  onConfirmPostpone,
  onSkipCompletely,
}: SyberryTodaySkipCheckInModalProps) => {
  const isActionDisabled = isPostponing || isSkipping;

  return (
    <Modal
      isOpen={isOpen}
      onToggle={onClose}
      title="Are you sure you want to skip daily check-in?"
      backdrop="static"
      modalSize="sm"
      paperStyles={{ maxWidth: '620px' }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        <Typography variant="body1" color="textSecondary">
          You can still complete check-in at a later time but we recommend only skipping check-in if:
        </Typography>

        <Box
          component="ul"
          sx={{
            margin: '4px 0 24px',
            paddingLeft: 2.75,
            color: 'text.primary',
            fontSize: '14px',
            lineHeight: 1.45,
          }}
        >
          <li>There's an immediate action you have to take</li>
          <li>You are not meant to be working today</li>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 1,
            marginTop: 0.25,
            '@media (max-width: 600px)': {
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
            },
          }}
        >
          <Stack direction="row" gap={0.5}>
            <Typography variant="body1" color="textSecondary">
              Remind me in
            </Typography>
            <Typography variant="subtitle1" color="textPrimary">
              1 hour
            </Typography>
          </Stack>
          <Button
            type="button"
            variant="contained"
            color="secondary"
            sx={{ minHeight: '32px' }}
            disabled={isActionDisabled}
            onClick={onConfirmPostpone}
          >
            Confirm
          </Button>
        </Box>

        <Button
          type="button"
          variant="text"
          sx={{
            alignSelf: 'flex-end',
            minWidth: 0,
            marginTop: 3.5,
            padding: 0,
            color: 'secondary.main',
            fontSize: '12px',
            fontWeight: 600,
            '&:hover': {
              background: 'transparent',
              textDecoration: 'underline',
            },
            '@media (max-width: 600px)': {
              alignSelf: 'flex-start',
            },
          }}
          disabled={isActionDisabled}
          onClick={onSkipCompletely}
        >
          Skip Check-In Completely
        </Button>
      </Box>
    </Modal>
  );
};

export default SyberryTodaySkipCheckInModal;
